























import { Component, Vue } from 'vue-property-decorator';
import ToggleButton from '@/components/common/ToggleButton.vue';
import { FulfillmentMethod } from '@/enums/fulfillment-method';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import { CurbsideModel } from '@/models/CurbsideModel';
import CurbsidePopup from '@/components/popups/curbside-popup/CurbsidePopup.vue';
import ActionTypes from '@/constants/action-types';
import PickupSelect from '@/components/common/PickupSelect.vue';

@Component({
  components: { PickupSelect, CurbsidePopup, ToggleButton },
})
export default class FulfillmentOptions extends Vue {
  private isCurbsidePopupOpen = false;

  private get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  private get curbsideAvailable(): boolean {
    return this.merchant?.curbsidePickup;
  }

  private get curbsideData(): CurbsideModel | null {
    return this.$store.state.curbsideData;
  }

  private get selectedMethod(): FulfillmentMethod {
    return this.curbsideData ? FulfillmentMethod.Curbside : FulfillmentMethod.PickUp;
  }

  private get pickUp(): FulfillmentMethod {
    return FulfillmentMethod.PickUp;
  }

  private get curbside(): FulfillmentMethod {
    return FulfillmentMethod.Curbside;
  }

  private onMethodChange(fulfillmentMethod: FulfillmentMethod): void {
    if (fulfillmentMethod === FulfillmentMethod.Curbside) {
      this.isCurbsidePopupOpen = true;
    }
    if (fulfillmentMethod === FulfillmentMethod.PickUp) {
      this.$store.commit(ActionTypes.SetCurbsideData, null);
    }
  }

  private onCurbsideSave(curbsideData: CurbsideModel): void {
    this.$store.commit(ActionTypes.SetCurbsideData, curbsideData);
    this.isCurbsidePopupOpen = false;
  }
}
